import ModalBase from '@/app/customComponents/modals/ModalBase';
import SuccessCircleCheckIcon from '@shared/icons/SuccessCircleCheck';
import { LinearProgress, withStyles } from '@material-ui/core';
import React from 'react';

const BorderLinearProgress = withStyles((theme) => {
	return {
		root: {
			height: 10,
			borderRadius: 5,
		},
		colorPrimary: {
			backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
		},
		bar: {
			borderRadius: 5,
			backgroundImage: 'linear-gradient(90deg, #171B8E  0%, #2F6EFF 100%)',
		},
	};
})(LinearProgress);

const DownloadProgressModal = ({ open, setOpen, progress = 0, downloadLink, setDownloadLink }) => {
	const onClose = () => {
		setDownloadLink(null);
	};

	return (
		<ModalBase
			dismissible={downloadLink === null ? false : true}
			onClose={onClose}
			open={open}
			setOpen={setOpen}
			showClose={downloadLink === null ? false : true}
			showX={downloadLink === null ? false : true}
		>
			<div className="flex items-center justify-center">
				{downloadLink === null ? (
					<div className="flex flex-col items-center justify-center gap-32">
						<div className="flex flex-col items-center justify-center gap-8">
							<p className="text-pd-lg font-bold">Preparing your download</p>
							<p>Please wait.</p>
						</div>
						<BorderLinearProgress className="border w-full" value={progress} variant="determinate" />
					</div>
				) : (
					<div className="flex flex-col items-center justify-center gap-24">
						<SuccessCircleCheckIcon className="size-48" />
						<div className="flex flex-col items-center justify-center gap-8 text-center">
							<p className="text-pd-lg font-bold">Success!</p>
							<p>Your download should begin automatically.</p>
							<p>
								If not, please{' '}
								<a className="text-blue-500 hover:underline" download href={downloadLink}>
									click here
								</a>{' '}
								to download.
							</p>
						</div>
					</div>
				)}
			</div>
		</ModalBase>
	);
};

export default DownloadProgressModal;
